import $ from 'jquery';

export default function() {

	$('.js_gtm_cta-link').on('click', function(e) {
		dataLayer.push({
      'event': 'ga_event',
      'eventData': {
          'category': 'CTA_Link',
          'action': $(e.currentTarget).attr('href'),
          'label': '',
          'value': 0
      }
    });
	});

	$('.js_gtm_cta-download').on('click', function(e) {
    dataLayer.push({
      'event': 'ga_event',
      'eventData': {
          'category': 'CTA_Link',
          'action': $(e.currentTarget).attr('href'),
          'label': '',
          'value': 0
      }
    });
	});

	$('.js_gtm_cta-product').on('click', function(e) {
    dataLayer.push({
      'event': 'ga_event',
      'eventData': {
          'category': 'CTA_Link',
          'action': $(e.currentTarget).attr('href'),
          'label': '',
          'value': 0
      }
    });
	});

	/*$('body').on('GTM_CTA_NL_STEP1', function() {
		dataLayer.push({"event": "CTA_Newsletter", "vGtm1": window.location.pathname, "vGtm2": "1st part"});
	}).on('GTM_CTA_NL_STEP2', function() {
		dataLayer.push({"event": "CTA_Newsletter", "vGtm1": window.location.pathname, "vGtm2": "2nd part"});
	});*/

};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/gtm-event/cta-events.js